import React, { useState } from "react";
import { Info, ArrowLeft, ClipboardList } from "lucide-react";
import Swal from "sweetalert2";
export default function StepAgreement({ onNext }) {
  const [agreed, setAgreed] = useState(false);

  const handleNext = () => {
    if (!agreed) {
      Swal.fire({
        title: "توجه",
        text: "لطفاً برای ادامه، شرایط و ضوابط را مطالعه و تایید نمایید.",
        icon: "warning",
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "#2b2b2b",
      });
      return;
    }
    onNext();
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-3 mb-6 border-b border-slate-100 pb-4">
        <div className="bg-gray-100 p-2.5 rounded-xl text-[#2b2b2b]">
          <Info size={24} />
        </div>
        <div>
          <h2 className="text-xl font-bold text-slate-800">راهنمایی و شروع</h2>
          <p className="text-sm text-slate-500 mt-1">
            لطفاً قبل از شروع، قوانین و شرایط را با دقت مطالعه کنید
          </p>
        </div>
      </div>

      <div className="flex-1 bg-slate-50 rounded-2xl p-5 md:p-6 border border-slate-100 text-sm text-slate-700 leading-loose space-y-5 h-full overflow-y-auto custom-scrollbar">
        <div className="text-justify leading-8 space-y-4">
          <p>
            به سیستم نوبت دهی مراکز خدمات پس از فروش شرکت برساوش تجارت نیک خوش آمدید. در این قسمت شما می توانید براساس خدمت مورد نظر خود نسبت به انتخاب نمایندگی خدمات پس از فروش سرویس دهنده خدمت و همچنین زمان انجام خدمات اقدام نمایید. برای ثبت نوبت در سامانه نوبت دهی شرکت برساوش تجارت نیک، لازم است اطلاعات خودرو و اطلاعات مالک یا آورنده خودرو را در سیستم ثبت نمایید. در پایان فرآیند نوبت دهی، سیستم برای شما کد رهگیری تولید نموده و آن را برای شما پیامک خواهد کرد. که باید در هنگام مراجعه به مرکز ارائه کننده سرویس کد پیگیری مربوطه را ارائه نمایید.
          </p>
        </div>

        <div className="pt-2">
          <p className="font-bold text-slate-800 mb-3 text-base">مشتری محترم لطفا به نکات زیر توجه فرمایید :</p>
          <ul className="space-y-4 list-disc list-inside marker:text-gray-400 text-justify leading-8">
            <li>خواهشمند است قبل از تحویل خودرو به تعمیرگاه، نسبت به خارج نمودن لوازم شخصی خود اقدام نمایید. تعمیرگاه هیچ گونه مسئولیتی در قبال وسایل شخصی شما نخواهد داشت.</li>
            <li>جهت رویت بهتر بدنه و جلوگیری از مشكلات آتی، خواهشمند است ترتیبی اتخاذ فرمایید تا در هنگام تحویل خودرو به تعمیرگاه، خودرو تمیز و فاقد هرگونه آلودگی بوده تا امكان شناسایی ایرادات و خط و خش بدنه میسر باشد.</li>
            <li>جهت پذیرش و جلوگیری از آسیب احتمالی به سیستم سوخت رسانی خودرو، می بایست قبل از تحویل خودرو به تعمیرگاه حداقل 10 لیتر بنزین داخل مخزن سوخت موجود باشد.</li>
            <li>زمان احتمالی تحویل خودرو، متناسب با نوع سرویس درخواستی و پس از کارشناسی انجام شده توسط کارشناس تعمیرگاه در هنگام پذیرش حضوری از طریق مشاور سرویس به شما اعلام خواهد شد.</li>
            <li>ارائه کارت شناسایی خودرو و همچنین کارت شناسایی آورنده و یا مالک درهنگام پذیرش و ترخیص الزامی می باشد.</li>
          </ul>
        </div>
      </div>

      <div className="mt-8 flex flex-col md:flex-row items-center justify-between gap-6 p-5 bg-white border-2 border-slate-100 rounded-2xl transition-all hover:border-gray-200">
        <label className="flex items-center gap-3 cursor-pointer group w-full md:w-auto">
          <div className="relative">
            <input
              type="checkbox"
              className="sr-only"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
            <div className={`w-12 h-6 rounded-full transition-colors duration-300 ease-in-out flex items-center px-1 ${agreed ? 'bg-[#2b2b2b]' : 'bg-slate-300'}`}>
              <div className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-300 ease-in-out ${agreed ? '-translate-x-6' : 'translate-x-0'}`}></div>
            </div>
          </div>
          <span className="text-sm md:text-base font-bold text-slate-700 select-none group-hover:text-[#2b2b2b] transition-colors">
            اینجانب ضوابط و شرایط فوق را مطالعه کرده ام و با آن موافق هستم
          </span>
        </label>

        <button
          onClick={handleNext}
          className={`w-full md:w-auto flex items-center justify-center gap-2 py-3.5 px-8 rounded-xl font-bold transition-all
            ${agreed
              ? "bg-[#2b2b2b] hover:bg-neutral-800 text-white shadow-lg shadow-neutral-900/20 active:scale-95"
              : "bg-slate-100 text-slate-400 cursor-not-allowed"
            }`}
        >
          مرحله بعد
          <ArrowLeft size={18} />
        </button>
      </div>

    </div>
  );
}
